"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./enums"), exports);
__exportStar(require("./betprocessor/bet.dto"), exports);
__exportStar(require("./betprocessor/ticket.dto"), exports);
__exportStar(require("./bonus/bonus.dto"), exports);
__exportStar(require("./bonus/referral.dto"), exports);
__exportStar(require("./bonus/referred.user.dto"), exports);
__exportStar(require("./casino/bet.dto"), exports);
__exportStar(require("./casino/enum.dto"), exports);
__exportStar(require("./casino/favorite.dto"), exports);
__exportStar(require("./casino/free.round.dto"), exports);
__exportStar(require("./casino/game.dto"), exports);
__exportStar(require("./casino/session.dto"), exports);
__exportStar(require("./message/chat.dto"), exports);
__exportStar(require("./message/message.dto"), exports);
__exportStar(require("./payment/deposit.dto"), exports);
__exportStar(require("./payment/withdrawal.dto"), exports);
__exportStar(require("./payment/bankDetails.dto"), exports);
__exportStar(require("./payment/cryptoDetails.dto"), exports);
__exportStar(require("./payment/userAccount.dto"), exports);
__exportStar(require("./payment/transaction.dto"), exports);
__exportStar(require("./trading/scoreboard.dto"), exports);
__exportStar(require("./trading/feed.dto"), exports);
__exportStar(require("./trading/common.dto"), exports);
__exportStar(require("./trading/sport.dto"), exports);
__exportStar(require("./trading/category.dto"), exports);
__exportStar(require("./user/login.dto"), exports);
__exportStar(require("./user/recovery.dto"), exports);
__exportStar(require("./user/profile.dto"), exports);
__exportStar(require("./user/registration.dto"), exports);
__exportStar(require("./wallet/wallet.dto"), exports);
__exportStar(require("./wallet/transaction.dto"), exports);
__exportStar(require("./config.dto"), exports);
__exportStar(require("./exchangeRates.dto"), exports);
__exportStar(require("./crypto.dto"), exports);
__exportStar(require("./cms/media.dto"), exports);
__exportStar(require("./cms/popup.dto"), exports);
__exportStar(require("./cms/banner.dto"), exports);
__exportStar(require("./cms/banner.translations.dto"), exports);
__exportStar(require("./cms/reel.dto"), exports);
__exportStar(require("./cms/reel.translations.dto"), exports);
__exportStar(require("./cms/user-interface.dto"), exports);
__exportStar(require("./cms/notification.dto"), exports);
__exportStar(require("./document/file.dto"), exports);
__exportStar(require("./document/document.dto"), exports);
//# sourceMappingURL=index.js.map